import React from 'react';
import PropTypes from 'prop-types';

/**
 * Card component for content grouping
 * Supports header, body, footer with proper spacing
 */
const Card = ({
  header,
  footer,
  children,
  className = '',
  bordered = false,
  shadow = true,
  padding = 'md',
}) => {
  const shadowClass = shadow ? 'tw-shadow-sm' : '';
  const borderClass = bordered ? 'tw-border tw-border-slate-200' : '';

  const paddingClasses = {
    none: 'tw-p-0',
    sm: 'tw-p-3',
    md: 'tw-p-4',
    lg: 'tw-p-6',
  };

  const headerClass = header ? 'tw-border-b tw-border-slate-200 tw-px-4 tw-py-3' : '';
  const footerClass = footer ? 'tw-border-t tw-border-slate-200 tw-px-4 tw-py-3' : '';
  const bodyPadding = paddingClasses[padding];

  return (
    <div className={`tw-bg-white tw-rounded ${shadowClass} ${borderClass} ${className} tw-overflow-hidden`}>
      {header && (
        <div className={`${headerClass} tw-bg-slate-50`}>
          {typeof header === 'string' ? (
            <h3 className="tw-font-semibold tw-text-sm tw-text-slate-900">{header}</h3>
          ) : (
            header
          )}
        </div>
      )}

      <div className={bodyPadding}>{children}</div>

      {footer && (
        <div className={`${footerClass} tw-bg-slate-50`}>
          {typeof footer === 'string' ? (
            <p className="tw-text-xs tw-text-slate-600">{footer}</p>
          ) : (
            footer
          )}
        </div>
      )}
    </div>
  );
};

Card.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  bordered: PropTypes.bool,
  shadow: PropTypes.bool,
  padding: PropTypes.oneOf(['none', 'sm', 'md', 'lg']),
};

export default Card;
